import type {} from '@redux-devtools/extension' 
import Questionizer from './components/questionizer';
import { useEffect } from 'react';
import { useQuestionizerStore } from './types/state';
import { TranslationMap } from './translation';

export default function App(props: {className?: string, configPath: string | null | undefined, translation_map?: TranslationMap}) {
  const config = useQuestionizerStore((state) => state.config);
  const loadConfig = useQuestionizerStore((state) => state.loadConfig);
  const requestStatistics = useQuestionizerStore((state) => state.requestStatistics);
  const setTranslationMap = useQuestionizerStore((state) => state.setTranslationMap);

  const sendStatisticsInterval = 3000; //3 seconds
  useEffect(()=>{
    if(!props.configPath){return;}
    if (config){ return; } 
    loadConfig(props.configPath);
    setTranslationMap(props.translation_map);
    requestStatistics();
    const interval = setInterval(()=>{
      requestStatistics();
    }, sendStatisticsInterval);
    return ()=>{clearInterval(interval)};
  },[]);

  if (!props.configPath || !config) { return; }

  // let style = config.style;
  // let parsed_style = Object.keys(style)
  //   .map(element => [element, element.split(',').map(s => ".fbq "+s).join(',')])
  //   .map(element => `${element[1]}{${Object.keys(style[element[0]])
  //     .map( s => `${s.toString()}:${style[element[0]][s]}`)
  //     .join(';')}}`)
  //   .join(' ');
  
    return <>
        {/* <style>{parsed_style}</style> */}
        <Root className={props.className}/>
    </>
  }

function Root(props: {className?: string}){
  return <div className={"questionizer-root questionizer-container w-full h-full flex flex-col font-sans "+(props.className || "")}>
      <Questionizer />
  </div>
}